import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=5242ee96&scoped=true&lang=pug"
var script = {}
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=5242ee96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242ee96",
  null
  
)

export default component.exports